module.exports = __webpack_public_path__ + "static/media/sonbahar-Photoroom.990145c7.jpg";